import "./scss/custom";
import $ from "jquery";
import popper from "popper.js";
import bootstrap from "bootstrap";
import * as d3 from "d3";

$(document).ready(function(e) {
  $("#carouselFade").carousel();

  const width = $(".container-home").width();
  const height = $(".container-home").height();
  const scaleX = d3
    .scaleLinear()
    .domain([0, width])
    .range([-6, 6]);

  const scaleY = d3
    .scaleLinear()
    .domain([0, height])
    .range([-8, 8]);

  const container = d3.select(".container-home");

  d3.select(".logo-container svg").attr("viewbox", "0 0 400 400");

  $(".container-home").mousemove(function(event) {
    const eyes = d3
      .selectAll("circle.cls-4")
      .attr(
        "transform",
        `translate(${scaleX(event.pageX)},${scaleY(event.pageY)})`
      );
  });
});
